import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import Spinner from './Spinner.jsx';

const LoadingSplashScreen = () => {
  const splashScreen = useArgSelector(selectors.pref, 'splashScreen') || {};
  const isLoading = splashScreen?.isLoading || false;
  const message = splashScreen?.message || 'Loading...';
  const fadeOut = splashScreen?.fadeOut || false;
  const showSpinner = 'showSpinner' in splashScreen ? splashScreen?.showSpinner : true;

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isLoading) {
        e.preventDefault();
        e.returnValue = 'The app is still loading. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isLoading]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className={`loading-splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loading-splash-screen__content">
        {showSpinner && <Spinner size={24} />}
        <div className="loading-splash-screen__message">{message}</div>
      </div>
    </div>
  );
};

export default LoadingSplashScreen;
